import KPurchaseOrdersTable from "kinnect-front/Sales/PurchaseOrders/KPurchaseOrdersTable";
import { FetchesData } from "kinnect-mixins";
import {
	KAutocomplete,
	KForm,
	KTextField,
	KTextarea
} from "kinnect-general";
import { TransactionErrorType } from "kinnect-models";
import { VCard } from "vuetify/lib";
import { consoleWarn } from "vuetify/lib/util/console";
import { formatCurrency } from "kinnect-formatters";

export const defaultPurchaseOrdersTableProps = {
	hiddenCols: "actions",
	items: null
};

export default KForm.extend( {
	name: "KPurchaseOrderErrorForm",

	mixins: [ FetchesData ],

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "salesPurchaseOrders" } ]
		},

		purchaseOrderError: Object,

		purchaseOrdersTableProps: {
			default: () => defaultPurchaseOrdersTableProps,
			type: Object
		}
	},

	data: () => ( {
		errorTypes: [],
		formFields: {
			cost: null,
			error: null,
			errorTypes: [],
			purchaseOrders: []
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.purchaseOrderError );
		},

		formUrl() {
			const baseUrl = "sales/purchase-orders/errors";

			return this.editing ? `${baseUrl}/${this.purchaseOrderError.id}` : baseUrl;
		},

		$_purchaseOrdersTableProps() {
			return {
				...defaultPurchaseOrdersTableProps,
				...this.purchaseOrdersTableProps
			};
		},

		selectedPurchaseOrders: {
			get() {
				if ( this.$_purchaseOrdersTableProps.items && this.formFields.purchaseOrders ) {
					return this.$_purchaseOrdersTableProps.items.filter(
						purchaseOrder => this.formFields.purchaseOrders.indexOf( purchaseOrder.id ) !== -1
					);
				}

				return [];
			},
			set( val ) {
				this.formFields.purchaseOrders = val ? val.map( item => item.id ) : null;
			}
		}
	},

	watch: {
		"$_purchaseOrdersTableProps.value": {
			handler( val ) {
				this.selectedPurchaseOrders = val;
			},
			immediate: true
		},

		purchaseOrderError: {
			handler( purchaseOrderError ) {
				if ( purchaseOrderError ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( purchaseOrderError.hasOwnProperty( key ) && key !== "purchaseOrders" ) {
							this.formFields[key] = purchaseOrderError[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchErrorTypes() {
			this.errorTypes = await TransactionErrorType.get();
		},

		async fetch() {
			await this.fetchErrorTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<VCard class="mb-4" outlined>
				<KPurchaseOrdersTable
					attrs={this.$_purchaseOrdersTableProps}
					vModel={this.selectedPurchaseOrders}
					validationName="purchase order"
					validationRules="required"
				>
					<template slot="title">
						{this.$_purchaseOrdersTableProps.showSelect
							? "Select Purchase Order(s) Associated with Error*"
							: "Purchase Order(s) Associated with Error"
						}

					</template>
				</KPurchaseOrdersTable>
			</VCard>

			<KAutocomplete
				chips
				class="ml-blank-icon"
				deletableChips
				groupBy="category"
				itemText="name"
				itemValue="id"
				items={this.errorTypes}
				label="Error Type(s)*"
				loading={this.$wait.is( "get transaction error types" )}
				multiple
				required
				vModel={this.formFields.errorTypes}
				validationName="error type(s)"
				validationRules="required"
			></KAutocomplete>

			<KTextField
				hint={this.formFields.cost ? formatCurrency( this.formFields.cost ) : ""}
				label="Error Cost"
				onInput={val => this.formFields.cost = val ? parseFloat( val ) : null}
				persistentHint
				prependIcon="attach_money"
				type="number"
				validationName="error cost"
				validationRules="min_value:0"
				value={this.formFields.cost}
			></KTextField>

			<KTextarea
				label="Error Notes*"
				prependIcon="comment"
				required
				vModel={this.formFields.error}
				validationName="error notes"
				validationRules="required"
			></KTextarea>
		</KForm>;
	},

	created() {
		if ( !Array.isArray( this.purchaseOrdersTableProps.items ) ) {
			consoleWarn( "purchaseOrdersTableProps.items is required and must be an array", this );
		}
	}
} );
